angular.module("UI8.services").service("CategoryService", [
  "$http",
  "PreloadService",
  function ($http, PreloadService) {
    // Plain page one, no filters: the only request the server can have
    // pre-rendered (it cannot see the sessionStorage filters).
    function isPlainPageOne(options) {
      if (!options) return true;
      return Object.keys(options).every(function (key) {
        if (key === "page") return String(options.page) === "1";
        if (key === "ff") return !options.ff;
        return false;
      });
    }

    this.list = function () {
      return $http.get("/api/categories").then(
        function (response) {
          if (response.error) return [];
          return response.data;
        },
        function () {
          return [];
        }
      );
    };

    this.findBySlug = function (slug, options) {
      return new Promise(function (resolve) {
        var queryString = "";
        var sessionSoftware = sessionStorage.getItem(
          slug + ":category-software-filter"
        );
        var sessionFeatured = sessionStorage.getItem(
          slug + ":category-featured-filter"
        );
        var sessionHasDesignDna = sessionStorage.getItem(
          slug + ":category-has-dna-filter"
        );
        var sessionSort = sessionStorage.getItem(slug + ":category-sort");

        if (!options && (sessionSoftware || sessionFeatured || sessionHasDesignDna || sessionSort)) {
          options = {};
        }

        if (
          !options.compatibility &&
          sessionSoftware &&
          sessionSoftware !== "Any Platform"
        )
          options.compatibility = sessionSoftware;
        if (!options.featured && sessionFeatured)
          options.featured =
            options.featured === false ? null : sessionFeatured;
        if (!options.hasDesignDna && sessionHasDesignDna)
          options.hasDesignDna = sessionHasDesignDna;
        if (!options.sort && sessionSort) options.sort = sessionSort;

        // Inlined by the category shell on the first load
        var preloaded = PreloadService.peek("category");
        if (preloaded && preloaded.slug === slug && isPlainPageOne(options)) {
          PreloadService.take("category");
          return resolve(preloaded.data);
        }

        if (options) {
          var params = new URLSearchParams(options).toString();
          queryString = "?" + params;
        }

        return $http.get("/api/categories/" + slug + queryString).then(
          function (response) {
            if (response.error) return resolve({});
            return resolve(response.data.data);
          },
          function () {
            return resolve({});
          }
        );
      });
    };
  },
]);
